export const ENDPOINTS = {
    SUBMIT_FEEDBACK: '/workorder/v1/submit',
    DROP_INQUIRY_REASON_MAP: (type: string) => `/workorder/v1/drop/reason/inquiry/${type}`,
    DROP_INQUIRY_TYPE: (type: string) => `/workorder/v1/drop/inquiry/${type}`,
};